




















































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { onlyFloat, truncateText, validateLength, timeout, isNull, capitalizeCase } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { Procedimento, GrupoOpme, GrupoOpmes } from '@/types/_'
import { SolicitacaoGrupoOpme } from '@/types/interfaces/Solicitacao'
import { IProtocoloKitDeOpmeV2, SolicitacaoOpme } from '@/types/interfaces/protocolo/protocolo.interface'
import SolicitacaoStore from '../store/SolicitacaoStore'

@Component
export default class ComponentModalOPME extends Vue {
  @Prop({ required: true, default: {} }) procedimentoPrincipal: Procedimento
  @Prop({ required: false, default: [] }) procedimentoAssociado: Procedimento[]

  $refs!: {
    formNovoFornecedor: any,
    formGrupoOpme: any,
    cardGrupoOpme: any,
    fornecedor1: any,
    fornecedor2: any,
    fornecedor3: any,
    formNovoOPME: any,
  }

  mdeditKit: boolean = false
  loadClose: boolean = false
  loadAdicionarOPME: boolean = false
  loadEditClose: boolean = false
  loadSaveOPME: boolean = false
  loadSaveFornecedor: boolean = false
  loadConfirmar: boolean = false
  loadDeleteKitOpme: boolean = false
  boxNovoFornecedor: boolean = false
  descricao: string = ''
  fornecedor: string = ''
  numCampos: number = 1
  nvOPME: boolean = false
  busca: string = ''
  fornecedoresRulesTemplate: any = {
    fornecedor1Id: false,
    fornecedor2Id: false,
    fornecedor3Id: false,
  }

  isOpmeClone = false
  grupoOpmeToEdit = { opmes: [{}] as GrupoOpmes[] } as GrupoOpme

  showModalConfirmarDeleteGrupoOpme = false
  kitDeMateriaisToDeleteId = ''

  capitalizeCaseUtil(value: string) {
    return capitalizeCase(value)
  }

  get fornecedorLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorLabel
      ? this.getTemplate.opmes.fornecedorLabel
      : 'fornecedor / marca'
  }

  get fornecedorButtonLabel() {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.fornecedorButtonLabel
      ? this.getTemplate.opmes.fornecedorButtonLabel
      : 'Cadastrar fornecedor'
  }


  get getFornecedoresRules() {
    return this.fornecedoresRulesTemplate
  }

  set getFornecedoresRules(rules: any) {
    this.fornecedoresRulesTemplate = rules
  }

  fornecedorAtivo(fornecedor) {
    return this.getTemplate && this.getTemplate.opmes && this.getTemplate.opmes.campos && this.getTemplate.opmes.campos[fornecedor]
  }

  validateFornecedor(value: string, templateField) {
    if (!this.getTemplate) {
      return true
    }

    const { opmes } = this.getTemplate

    if (!opmes) {
      return true
    }

    if (opmes.campos[templateField] && opmes[templateField].obrigatorio && ['', null, undefined].includes(value)) {
      return 'Campo obrigatório.'
    }

    if (opmes.campos[templateField] && !opmes[templateField].permiteNaoInformado && value === this.NAO_INFORMADO) {
      return 'Por favor, informe um fornecedor válido.'
    }

    return true
  }

  formGrupoOpmeRules: any = {
    valid: true,
    nomeDoKit: [v => !!v || 'Campo obrigatório'],
    fornecedor1Id: [v => this.validateFornecedor(v, 'fornecedor1Id')],
    fornecedor2Id: [v => this.validateFornecedor(v, 'fornecedor2Id')],
    fornecedor3Id: [v => this.validateFornecedor(v, 'fornecedor3Id')],
    opme: [v => (!!v && !!v.id) || 'Campo obrigatório.'],
    quantidade: [v => (!!v && parseFloat(v) > 0) || 'Campo obrigatório.'],
  }

  /**
   * ------------------------------------------------------------------------------------------
   * NOVA VALIDAÇÃO DE FORNECEDORES
   * __________________________________________________________________________________________
   */
  // Id do fornecedor 'Não Informado'
  NAO_INFORMADO = '50a949cc-7c46-4f86-a160-90b95371b542'

  possuiOMesmoFornecedor(id1: string | undefined, id2: string | undefined, id3: string | undefined) {
    if (!isNull(id1) && !isNull(id2) && !isNull(id3)) return id1 === id2 || id1 === id3 || id2 === id3
    if (!isNull(id1) && !isNull(id2) && isNull(id3)) return id1 === id2
    if (!isNull(id1) && isNull(id2) && !isNull(id3)) return id1 === id3
    if (isNull(id1) && !isNull(id2) && !isNull(id3)) return id2 === id3
    return false
  }

  validarDuplicatas() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      const fornecedor1 = this.fornecedorAtivo('fornecedor1Id') ? this.$refs.fornecedor1[i].value : ''
      const fornecedor2 = this.fornecedorAtivo('fornecedor2Id') ? this.$refs.fornecedor2[i].value : ''
      const fornecedor3 = this.fornecedorAtivo('fornecedor3Id') ? this.$refs.fornecedor3[i].value : ''
      isFormValid.push(this.possuiOMesmoFornecedor(fornecedor1, fornecedor2, fornecedor3))
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === true)
  }

  validarFornecedores() {
    const isFormValid: boolean[] = []
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      isFormValid.push(this.$refs.formGrupoOpme[i].validate())
    }

    isFormValid.forEach((form: boolean, index: number) => {
      if (!form) this.pointError(index)
    })

    return isFormValid.some((e: boolean) => e === false)
  }

  async pointError(index: number) {
    this.$refs.cardGrupoOpme[index].$el.style.background = 'rgba(255,0,0,.05)'
    await timeout(8500)
    if (this.$refs.cardGrupoOpme[index] && this.$refs.cardGrupoOpme[index].$el) {
      this.$refs.cardGrupoOpme[index].$el.style.background = 'transparent'
    }
  }

  resetValidacaoFornecedores() {
    for (let i = 0; i < this.$refs.formGrupoOpme.length; i++) {
      this.$refs.formGrupoOpme[i].resetValidation()
      this.$refs.formGrupoOpme[i].reset()
    }
  }

  /**
   * ------------------------------------------------------------------------------------------
   */

  novoFornecedorRules: any = {
    valid: true,
    fornecedorRules: [
      v => !!v || `O campo ${this.fornecedorLabel} é obrigatório.`,
      v => validateLength(v, 3) || `O campo ${this.fornecedorLabel} deve ter pelo menos 3 caracteres.`,
    ],
  }

  novoOPMERules: any = {
    valid: true,
    descricaoRules: [v => !!v || 'Campo obrigatório.'],
  }

  clearObservacao(opme: any) {
    // if (!opme.possuiGrade) {
    //   opme.observacao = ''
    // }
  }

  setFornecedoresRules() {
    const { formulario } = this.getSolicitacaoCirurgiaStore.template
    const fornecedores = formulario && formulario.opmes && formulario.opmes.campos
      ? formulario.opmes.campos
      : { fornecedor1Id: false, fornecedor2Id: false, fornecedor3Id: false }
    this.getFornecedoresRules = fornecedores
  }

  @Watch('showModalOPME')
  async onChangeShowModalOPME(value) {
    await setTimeout(() => {
      const input = document.querySelector('.opme-input input') as HTMLInputElement
      if (value) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
    value && this.setFornecedoresRules()
  }

  @Watch('showModalCadastroFornecedores')
  async onChangeShowModalCadastroFornecedores(value: boolean) {
    if (!value) {
      this.$nextTick(async () => {
        this.$refs.formNovoFornecedor.resetValidation()
        this.$refs.formNovoFornecedor.reset()
        this.getSolicitacaoCirurgiaStore.clearNovoFornecedor()
      })
    }
  }

  @Watch('showModalCadastroOPME')
  async onChangeShowModalCadastroOPME(value: boolean) {
    if (!value) {
      this.$nextTick(async () => {
        this.$refs.formNovoOPME.resetValidation()
        this.$refs.formNovoOPME.reset()
        this.getSolicitacaoCirurgiaStore.clearNovoOPME()
      })
    }
  }

  adicionarItemOPME() {
    if (this.validarFormAdicionarItem()) {
      this.grupoOpme.push({} as any)
    }
  }

  async removeItemOPME(index: number) {
    if (this.grupoOpme.length === 1) return
    const opmeId = this.grupoOpme[index].opme ? this.grupoOpme[index].opme.id : ''
    const opme = this.getSolicitacaoCirurgiaStore.listaMedicoOpme.find((e: any) => e.id === opmeId)
    if (opme) opme.disabled = false
    this.grupoOpme.splice(index, 1)
  }

  get getTemplate() {
    return this.getSolicitacaoCirurgiaStore.currentTemplate.formulario
  }

  get showModalCadastroOPME() { return this.getSolicitacaoCirurgiaStore.modal.cadastrarMaterial }
  set showModalCadastroOPME(value: boolean) {
    this.getSolicitacaoCirurgiaStore.setShowModalCadastrarMaterial(value)
  }

  get showModalCadastroFornecedores() { return this.getSolicitacaoCirurgiaStore.modal.cadastrarFornecedor }
  set showModalCadastroFornecedores(value: boolean) {
    this.getSolicitacaoCirurgiaStore.setShowModalCadastrarFornecedor(value)
  }

  get loadingConfirmar() { return this.loadConfirmar }
  set loadingConfirmar(value: boolean) { this.loadConfirmar = value }

  get loadingAdicionarOPME() { return this.loadAdicionarOPME }
  set loadingAdicionarOPME(value: boolean) { this.loadAdicionarOPME = value }

  get loadingSaveOPME() { return this.loadSaveOPME }
  set loadingSaveOPME(value: boolean) { this.loadSaveOPME = value }

  get loadingSaveFornecedor() { return this.loadSaveFornecedor }
  set loadingSaveFornecedor(value: boolean) { this.loadSaveFornecedor = value }

  get grupoOpme() { return this.grupoOpmeToEdit.opmes }

  get novoFornecedor() {
    return this.getSolicitacaoCirurgiaStore.novoFornecedor
  }

  get opmes() { return this.grupoOpmeToEdit.opmes }

  get getOpmes() { return this.getSolicitacaoCirurgiaStore.grupoOpme.opmes }
  set getOpmes(value: any[]) { this.getSolicitacaoCirurgiaStore.setGrupoOpmes(value) }

  truncateTitle(str: string) {
    return truncateText(str, 16)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get OPMES() {
    const opmes = this.getSolicitacaoCirurgiaStore.kitOpmeOptions
    return opmes.filter((e: any) => e.descricao.toLowerCase().includes(this.busca.toLowerCase()))
  }

  get OPMESV2() {
    const opmes = this.getSolicitacaoCirurgiaStore.kitOpmeV2Options
    return opmes.filter(e => e.nome.toLowerCase().includes(this.busca.toLowerCase()))
  }

  get fornecedores() {
    return this.getSolicitacaoCirurgiaStore.fornecedorOptions
  }

  get numeroDeCampos() { return this.numCampos }
  set numeroDeCampos(value: number) { this.numCampos = value }

  get showModalOPME() { return this.getSolicitacaoCirurgiaStore.modal.opme }
  set showModalOPME(value: boolean) { this.getSolicitacaoCirurgiaStore.setShowModalOPME(value) }

  get loadingClose() { return this.loadClose }
  set loadingClose(value: boolean) { this.loadClose = value }

  get showModalEditKit() { return this.mdeditKit }
  set showModalEditKit(value: boolean) { this.mdeditKit = value }

  get loadingEditClose() { return this.loadEditClose }
  set loadingEditClose(value: boolean) { this.loadEditClose = value }

  get novoOPME() { return this.nvOPME }
  set novoOPME(value: boolean) { this.nvOPME = value }

  setOPMEsToSave(opmes: any[]) {
    if (!opmes || opmes.length === 0) return []
    return opmes.map((opme: any) => {
      const op = {
        opmeId: opme.opme ? opme.opme.id : '',
        quantidade: opme.quantidade || 0,
        gradeCompleta: opme.gradeCompleta || false,
        fornecedor1Id: opme.fornecedor1Id || null,
        fornecedor2Id: opme.fornecedor2Id || null,
        fornecedor3Id: opme.fornecedor3Id || null,
        observacao: opme.observacao || null,
      }
      return op
    })
  }

  cancelDeleteKitDeMateriais() {
    this.kitDeMateriaisToDeleteId = ''
    this.showModalConfirmarDeleteGrupoOpme = false
  }

  async setKitDeMateriaisToDelete(grupoOpmeId: string) {
    this.kitDeMateriaisToDeleteId = grupoOpmeId
    this.showModalConfirmarDeleteGrupoOpme = true
  }

  async deleteKitDeMateriais() {
    this.loadDeleteKitOpme = true

    const res = await this.getSolicitacaoCirurgiaStore.deleteGrupoOpme(this.kitDeMateriaisToDeleteId)

    if (res.success) {
      const message = 'Kit de materiais deletado com sucesso'
      EventBus.$emit('setSnackbar', { show: true, text: `${message} ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
    } else {
      const message = 'Houve um erro ao deletar o Kit de materiais'
      EventBus.$emit('setSnackbar', { show: true, text: `${res.message || message} ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828', timeout: 5500 })
    }

    this.kitDeMateriaisToDeleteId = ''
    this.showModalConfirmarDeleteGrupoOpme = false

    this.loadDeleteKitOpme = false
  }

  async upsertKitDeMateriais() {
    this.loadingConfirmar = true

    if (this.validarDuplicatas()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Um material não pode ter fornecedor(es) duplicado(s)!', icon: 'warning', color: '#C62828', timeout: 5500 })
      this.loadingConfirmar = false
      return
    }

    if (this.validarFornecedores()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Verifique o(s) erro(s) abaixo.', icon: 'warning', color: '#C62828', timeout: 5500 })
      this.loadingConfirmar = false
      return
    }

    if (!this.grupoOpmeToEdit.descricao) {
      EventBus.$emit('setSnackbar', { show: true, text: 'É necessário informar o nome do Kit', icon: 'warning', color: '#C62828', timeout: 5500 })
      this.loadingConfirmar = false
      return
    }

    const isFormValid = this.validarFormAdicionarItem()

    if (isFormValid) {
      const data: any = {
        grupoOpmeId: this.grupoOpmeToEdit.id || null,
        medicoId: this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.medicoSolicitanteId,
        descricao: this.grupoOpmeToEdit.descricao || null,
        justificativa: this.grupoOpmeToEdit.justificativa || null,
        procedimentoId: this.procedimentoPrincipal.id,
        opmes: this.setOPMEsToSave(this.grupoOpme),
      }

      if (this.isOpmeClone) {
        delete data.grupoOpmeId
      }

      const res = await this.getSolicitacaoCirurgiaStore.upsertMedicoGrupoOpme(data)

      if (res.success) {
        let message = ''
        if (this.isOpmeClone) {
          message = 'Kit clonado com sucesso.'
        } else if (this.grupoOpmeToEdit.id) {
          message = 'Kit editado com sucesso.'
        } else {
          message = 'Kit cadastrado com sucesso.'
        }

        EventBus.$emit('setSnackbar', { show: true, text: `${message} ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }

      await this.loadGrupoOpmeByMedico()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Existem campos não preenchidos nesta lista ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmar = false

    this.closeModalEditKit()
  }

  async loadGrupoOpmeByMedico() {
    const { procedimento, procedimentosAssociados } = this.getSolicitacaoStore.solicitacao
    const codigoProcedimentos: any[] = []
    if (procedimentosAssociados!.length > 0) {
      procedimentosAssociados!.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
    }
    codigoProcedimentos.unshift(procedimento!.codigo)
    await this.getSolicitacaoCirurgiaStore.getGrupoOpmeByMedico(codigoProcedimentos)
  }

  opmeDisabledChange() {
    this.getSolicitacaoCirurgiaStore.listaMedicoOpme.map((e: any) => {
      const opme = e
      opme.disabled = this.grupoOpme.some(op => op.opme.id === e.id)
      return opme
    })
  }

  closeModalOPME() {
    this.showModalOPME = false
    this.getSolicitacaoCirurgiaStore.clearOpmeGrupoId()
    this.busca = ''
  }

  closeModalEditKit() {
    this.showModalEditKit = false
    this.isOpmeClone = false
    this.grupoOpmeToEdit = { opmes: [{}] as GrupoOpmes[] } as GrupoOpme
    this.clearFormValidation()
    this.getSolicitacaoCirurgiaStore.clearOpmeFornecedorIndex()
    this.getSolicitacaoCirurgiaStore.clearOpmeGrupoId()
    this.getSolicitacaoCirurgiaStore.resetOPMEGrupo()
    this.getSolicitacaoCirurgiaStore.clearOpmeGrupoInicial()
    this.getSolicitacaoCirurgiaStore.clearNovoFornecedor()
    this.getSolicitacaoCirurgiaStore.clearNovoOPME()
    this.$refs.formNovoFornecedor.reset()
    this.$refs.formNovoFornecedor.resetValidation()
    this.$refs.formNovoOPME.reset()
    this.$refs.formNovoOPME.resetValidation()
    this.resetValidacaoFornecedores()
  }

  async opmeListEmpty() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getSolicitacaoCirurgiaStore.loadFornecedores()
    await this.getSolicitacaoCirurgiaStore.getMedicoOpme()
    EventBus.$emit('clearLoadingRequest')
    this.showModalEditKit = true
  }

  async criarKit() {
    this.loadingAdicionarOPME = true
    await this.getSolicitacaoCirurgiaStore.loadFornecedores()
    await this.getSolicitacaoCirurgiaStore.getMedicoOpme()
    this.grupoOpmeToEdit.descricao = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.procedimento!.descricao || ''
    this.showModalEditKit = true
    this.loadingAdicionarOPME = false
  }

  async editKit(opme: any) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    this.isOpmeClone = false

    await this.getSolicitacaoCirurgiaStore.loadFornecedores()
    await this.getSolicitacaoCirurgiaStore.getMedicoOpme()

    const json = JSON.stringify(opme)
    const clone: GrupoOpme = JSON.parse(json)
    this.grupoOpmeToEdit = clone
    this.getSolicitacaoCirurgiaStore.setOpmeGrupoId(clone.id || '')
    this.getSolicitacaoCirurgiaStore.setOpmeGrupo(clone)
    this.getSolicitacaoCirurgiaStore.enableOPMEs(clone)
    this.getSolicitacaoCirurgiaStore.enableFornecedores()

    EventBus.$emit('clearLoadingRequest')
    this.showModalEditKit = true
  }

  async cloneKit(opme: any) {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    this.isOpmeClone = true

    await this.getSolicitacaoCirurgiaStore.loadFornecedores()
    await this.getSolicitacaoCirurgiaStore.getMedicoOpme()

    const json = JSON.stringify(opme)
    const clone: GrupoOpme = JSON.parse(json)
    this.grupoOpmeToEdit = clone
    this.getSolicitacaoCirurgiaStore.setOpmeGrupoId(clone.id || '')
    this.getSolicitacaoCirurgiaStore.setOpmeGrupo(clone)
    this.getSolicitacaoCirurgiaStore.enableOPMEs(clone)
    this.getSolicitacaoCirurgiaStore.enableFornecedores()

    EventBus.$emit('clearLoadingRequest')
    this.showModalEditKit = true
  }

  useKit(opme: GrupoOpme) {
    const clonedGrupoOpme: GrupoOpme = JSON.parse(JSON.stringify(opme))
    const opmes: SolicitacaoOpme[] = clonedGrupoOpme.opmes.map((elem) => {
      const { id, descricao } = elem.opme
      const {
        quantidade,
        gradeCompleta,
        observacao,
        fornecedor1,
        fornecedor2,
        fornecedor3,
        fornecedor1Id,
        fornecedor2Id,
        fornecedor3Id,
        medicoPodeAlterarAQuantidade,
        quantidadeMinima,
        quantidadeMaxima,
        fornecedores,
        procedimentoBilateral,
        medidaTamanho,
      } = elem as any

      return {
        id,
        descricao,
        quantidade,
        gradeCompleta,
        observacao,
        fornecedor1,
        fornecedor2,
        fornecedor3,
        fornecedor1Id,
        fornecedor2Id,
        fornecedor3Id,
        medicoPodeAlterarAQuantidade,
        quantidadeMinima,
        quantidadeMaxima,
        fornecedores,
        procedimentoBilateral,
        medidaTamanho,
      }
    })

    const grupoDeOpme: SolicitacaoGrupoOpme = {
      id: clonedGrupoOpme.id,
      descricao: clonedGrupoOpme.descricao,
      opmes,
    }

    this.getSolicitacaoCirurgiaStore.upsertGrupoDeOpme(grupoDeOpme)

    this.closeModalOPME()
  }

  useKitV2(data: IProtocoloKitDeOpmeV2) {
    const clonedKit: IProtocoloKitDeOpmeV2 = JSON.parse(JSON.stringify(data))
    this.getSolicitacaoCirurgiaStore.upsertGrupoDeOpmeV2(clonedKit)
    this.closeModalOPME()
  }

  onlyFloatUtil(value) {
    return onlyFloat(value)
  }

  adicionarItem() {
    const isFormValid = this.validarFormAdicionarItem()

    if (isFormValid) {
      this.getSolicitacaoCirurgiaStore.adicionarOpmeDefault()
    }
  }

  validarFormAdicionarItem() {
    let isFormValid: boolean = true
    for (let i = 0; i < this.grupoOpme.length; i++) {
      if (!this.$refs.formGrupoOpme[i].validate()) {
        isFormValid = false
      }
    }
    return isFormValid
  }

  clearFormValidation() {
    for (let i = 0; i < this.grupoOpme.length; i++) {
      this.$refs.formGrupoOpme[i].reset()
      this.$refs.formGrupoOpme[i].resetValidation()
    }
  }

  cadastrarOPME() {
    this.novoOPME = !this.novoOPME
  }

  fornecedorChange(fornecedorId: string, fieldName: string) {
    this.grupoOpmeToEdit.opmes.forEach((grupo: any) => {
      if (!grupo[fieldName]) {
        // eslint-disable-next-line
        grupo[fieldName] = fornecedorId
      }
    })
  }

  async cadastrarMaterial() {
    this.loadingSaveOPME = true
    if (this.$refs.formNovoOPME.validate()) {
      const response = await this.getSolicitacaoCirurgiaStore.createNovoOPME()

      if (response) {
        this.showModalCadastroOPME = false
        EventBus.$emit('setSnackbar', { show: true, text: `Material adicionado com sucesso. Agora você pode selecioná-lo na lista de materiais. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
        this.getSolicitacaoCirurgiaStore.clearNovoOPME()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
        this.getSolicitacaoCirurgiaStore.clearNovoOPME()
      }
    }

    this.loadingSaveOPME = false
  }

  async cadastrarFornecedor() {
    this.loadingSaveFornecedor = true
    if (this.$refs.formNovoFornecedor.validate()) {
      const response = await this.getSolicitacaoCirurgiaStore.postFornecedor()
      if (response.success) {
        this.showModalCadastroFornecedores = false
        EventBus.$emit('setSnackbar', { show: true, text: `${this.fornecedorLabel} adicionado com sucesso. Agora você pode selecioná-lo na lista de fornecedores. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 4500 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingSaveFornecedor = false
  }

  deleteOpme(index) {
    this.getSolicitacaoCirurgiaStore.deleteOpmes(index)
    this.getSolicitacaoCirurgiaStore.opmeDisabledChangeOnDelete()
  }

  temFornecedorNaoHomologadoNoKit(opmes: any[]) {
    const temAlgumFornecedorNaoHomologado: boolean[] = []
    opmes.forEach((opme: any) => {
      temAlgumFornecedorNaoHomologado.push(opme.fornecedor1 && !!opme.fornecedor1.alertaFornecedorNaoHomologado)
      temAlgumFornecedorNaoHomologado.push(opme.fornecedor2 && !!opme.fornecedor2.alertaFornecedorNaoHomologado)
      temAlgumFornecedorNaoHomologado.push(opme.fornecedor3 && !!opme.fornecedor3.alertaFornecedorNaoHomologado)
    })
    return temAlgumFornecedorNaoHomologado.some((e: boolean) => e)
  }

  @Watch('novoOPME')
  onChangeNovoOPME(value) {
    if (!value) {
      this.getSolicitacaoCirurgiaStore.clearNovoOPME()
      this.$nextTick(() => {
        if (this.$refs.formNovoOPME) this.$refs.formNovoOPME.reset()
      })
    }
  }
}
